var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9148",
    "data-name": "Group 9148",
    transform: "translate(-18931 -13197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_325",
    "data-name": "Ellipse 325",
    transform: "translate(18931 13197)",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 44.5,
    r: 44.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 44.5,
    r: 44,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "delete_FILL0_wght300_GRAD0_opsz24",
    d: "M184.868-786.116a3.018,3.018,0,0,1-2.215-.918,3.019,3.019,0,0,1-.918-2.215v-22H180v-2.6h7.8v-1.533h10.4v1.533H206v2.6h-1.733v22a3.025,3.025,0,0,1-.91,2.223,3.024,3.024,0,0,1-2.223.91Zm16.8-25.133H184.334v22a.519.519,0,0,0,.15.383.52.52,0,0,0,.383.15h16.267a.51.51,0,0,0,.367-.167.51.51,0,0,0,.167-.367ZM188.5-792.183h2.6v-15.6h-2.6Zm6.4,0h2.6v-15.6h-2.6ZM184.334-811.25v0Z",
    transform: "translate(18783 14042.383)",
    fill: "#ef7b13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.d79bb35f4f93359d4471a770841102b6.svg";
export { ForwardRef as ReactComponent };